<!--used to display content when open a discovery tool project
-->
<template>
  <v-row class="dataContainer" no-gutters>
    <LeftNavigationPan
      :allTags="allTags"
      :allComments="allComments"
      :getTagsAndComments="getTagsAndComments"
      :projectDetails="projectDetails"
      :allUserObj="allUserObj"
      :allUserArr="allUserArr"
      :dataReady="dataReady"
      :dataTestId="`${dataTestId}__sidebar`"
    />

    <v-col :md="lhsCollapsed ? undefined : 9" class="py-5">
      <v-col class="containerMinHeightinner pa-0 mx-0 mb-0 mt-1">
        <v-row class="rightDashboardContainer mx-auto my-0">
          <v-col class="pa-0">
            <v-row no-gutters class="mb-8" v-if="!isArchive">
              <v-col>
                <v-row no-gutters align="start">
                  <v-col sm="4">
                    <h2 v-if="projectDetails">
                      {{ projectDetails.projectName }}
                    </h2>
                    <v-skeleton-loader
                      max-width="300"
                      type="text"
                      :loading="true"
                      v-else
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col sm="8" class="text-right">
                    <v-row>
                      <v-col sm="12" justify="end" class="py-0">
                        <template v-if="!projectDetails">
                          <v-skeleton-loader
                            flat
                            type="actions"
                            class="project-actions-loader"
                            :loading="true"
                          ></v-skeleton-loader>
                        </template>
                        <template v-else>
                          <x-button
                            v-if="canExportProject"
                            :color="primaryColor"
                            @click="toggleExportModal"
                            :disabled="isExportButtonDisabled"
                            buttonText="Export"
                            :data-test-id="`${dataTestId}__export-btn`"
                          />
                          <x-button
                            class="ml-2"
                            v-if="canArchiveProject"
                            color="#58e2c2"
                            @click="archiveProject"
                            buttonText="Archive Project"
                            :data-test-id="`${dataTestId}__archive-project-btn`"
                          />
                          <x-button
                            class="ml-2"
                            buttonText="Back to Search"
                            @click="backToSearch"
                            color="#58e2c2"
                            v-if="
                              projectDetails &&
                                projectDetails.projectStatus !==
                                  this.$enums.projectStatus.ARCHIVED &&
                                isArchives
                            "
                            :data-test-id="`${dataTestId}__back-to-search-btn`"
                          />
                          <ExportOptionsModal
                            v-if="exportDialogState"
                            operationType="Export"
                            :exportJobInProgress="loadingState"
                            @closeDialog="toggleExportModal"
                            @triggerExport="exportArchives"
                          />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!--
          Following routerwill load these 3 components based on URL
          0- /projects/:projectId will load page with search component
          1- /projects/:projectId/vault/:pageNumber will load page with vault component
          2- /projects/:projectId/archives will load saved archive list
          3- /projects/:projectId/archive/:archiveId will load a particular archive
              -->

            <v-tabs
              v-if="activeConnectors.length && !isArchive"
              slider-color="primary"
              v-model="activeTab"
              background-color="#ebeded"
              grow
            >
              <v-tab @click="gotoURL('archive')" :disabled="!dataReady" :data-test-id="`${dataTestId}__email-archive-tab`"
                >Email Archives
              </v-tab>
              <v-tab @click="gotoURL('vault')" :disabled="!dataReady" :data-test-id="`${dataTestId}__vault-archive-tab`"
                >Vault Archives
              </v-tab>
            </v-tabs>

            <router-view
              v-if="projectDetails"
              :key="$route.path"
              :allUserObj="allUserObj"
            ></router-view>

            <v-row justify="center">
              <v-dialog
                v-model="dialogOpen"
                persistent
                width="30%"
                content-class="customDialog"
              >
                <v-card flat tile>
                  <v-card-title>
                    Select export format
                    <v-btn
                      text
                      icon
                      class="close-icon"
                      @click="dialogOpen = false"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text flat class>
                    <v-radio-group v-model="selectedExportFormat" column>
                      <v-radio
                        label="Pdf (with annotations)"
                        value="PDF"
                      ></v-radio>
                      <v-radio label="Zip" value="ZIP" disabled></v-radio>
                      <v-radio label="Tar" value="TAR" disabled></v-radio>
                    </v-radio-group>
                  </v-card-text>
                  <v-card-actions class="px-10 py-7">
                    <v-row justify="end">
                      <x-button
                        outline
                        color="#58e2c2"
                        @click="closeDialog"
                        buttonText="Cancel"
                      />
                      <x-button
                        color="#58e2c2"
                        @click="exportArchives"
                        buttonText="Confirm"
                      />
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import EventBus from '@/EventBus';
import LeftNavigationPan from '@/components/Discovery/LeftNavigationPan.vue';
import ProjectService from '../../services/ProjectService';
import UserService from '../../services/UserService';
import store from './../../store/index';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { CancelToken } from 'axios';
const ExportOptionsModal = () =>
  import('@/components/ArchiveSearch/ExportOptionsModal/ExportOptionsModal');
export default {
  store,
  props: {
    isLeftDrawerPanOpen: Boolean,
    title: String
  },
  components: {
    LeftNavigationPan,
    ExportOptionsModal
  },
  provide() {
    return {
      $allUserObj: () => this.allUserObj
    };
  },
  data() {
    return {
      showTabs: false,
      activeTab: 0,
      dialogOpen: false,
      tab: null,
      selectedExportFormat: 'PDF',
      tags: this.$route.params.tagname,
      dataReady: false,
      allUserObj: {},
      allUserArr: [],
      allTags: null,
      allComments: [],
      projectDetails: null,
      projectId: null,
      project: {},
      lhsCollapsed: false,
      currentTabData: { total: 0, type: '' },
      exportSubscriptionDetails: {},
      isExportButtonDisabled: false,
      axiosSource: CancelToken.source(),
      exportDialogState: false,
      loadingState: false,
      dataTestId:'discovery-project'
    };
  },
  computed: {
    ...mapState(['userInformation']),
    primaryColor() {
      return this.$vuetify?.theme?.themes?.light?.primary;
    },
    tabCounts: function() {
      let tags = this.$route.params.tagname;
      if (this.currentTabData.type === 'EMAIL') {
        if (this.isTags && tags) {
          const tagsCount = this.getTagsCount();

          return {
            email: this.currentTabData.total,
            vault: tagsCount - this.currentTabData.total
          };
        }
        return {
          email: this.currentTabData.total,
          vault: this.projectDetails.archiveIds - this.currentTabData.total
        };
      } else if (this.currentTabData.type === 'VAULT_O365_ARCHIVE') {
        if (this.isTags && tags) {
          const tagsCount = this.getTagsCount();
          return {
            vault: this.currentTabData.total,
            email: tagsCount - this.currentTabData.total
          };
        }
        return {
          vault: this.currentTabData.total,
          email: this.projectDetails.archiveIds - this.currentTabData.total
        };
      }
      return { vault: 0, email: 0 };
    },
    isArchives: function() {
      return this.$route.path.indexOf('archives') !== -1;
    },
    isArchive: function() {
      if (this.$route.path.indexOf('archive') !== -1) {
        if (this.$route.path.indexOf('archives') !== -1) {
          return false;
        }
        return true;
      }
      return false;
    },
    isTags: function() {
      return this.$route.path.indexOf('tags') !== -1;
    },
    containerClass() {
      return this.isLeftDrawerPanOpen ? 'col-md-12' : 'col-md-9';
    },
    activeConnectors() {
      return this.connectorArchiveNameMap(
        null,
        'menu',
        'currentOrgActiveConnectors'
      );
    },
    isProjectOwner() {
      return this.projectDetails?.projectOwner === this.userInformation?.userId;
    },
    /**
     * If project is not archived it is active, then Either project owner or collaborator can export project
     * which means export button will be not display for any other user
     */
    canExportProject() {
      return (
        !this.isProjectArchived &&
        this.isArchives &&
        (this.isProjectOwner ||
          (this.projectDetails?.collaborators || []).includes(
            this.userInformation?.userId
          ))
      );
    },
    /**
     * Only project owner can archive project
     */
    canArchiveProject() {
      return !this.isProjectArchived && this.isProjectOwner;
    },
    isProjectArchived() {
      return (
        this.projectDetails.projectStatus === this.$enums.projectStatus.ARCHIVED
      );
    },
    isOrgOnboarded() {
      return this.onboardingStatus === this.$enums.onboardingStatus.done;
    }
  },
  watch: {
    $route: function() {
      this.emailVaultTabsDisplay();

      this.projectId = this.$route.params.projectId;
      this.dataReady = false;
      this.projectDetails = null;
      this.currentlyViewing = 'PROJECT';
      this.getProjectData(this.projectId);
    }
  },
  beforeDestroy() {
    // To cancel network call explicitly when user switch route before network call completes
    this.axiosSource.cancel(this.$message.CANCELLED);
  },
  mounted() {
    EventBus.$on('CURRENT_TAB_COUNT', data => {
      this.currentTabData = data;
    });
    this.emailVaultTabsDisplay();
    this.projectId = this.$route.params.projectId;

    this.getAllUsers();
    EventBus.$on('MINIFY_LEFT', minify => {
      this.lhsCollapsed = minify;
    });
    EventBus.$on('REFRESH_COLLABORATORS', () => {
      this.dataReady = false;
      this.getProjectData(this.projectId);
    });
    this.getExportProjectStatus();
  },
  methods: {
    ...mapGetters('discovery', ['getOpenProjects']),
    ...mapMutations('discovery', ['setOpenProjects']),
    /**
     * To get status of export job
     */
    async getExportProjectStatus() {
      try {
        const exportStatusData = await this.$services.project.getExportProjectStatus();
        const exportStatus = this.parseResponse(exportStatusData);
        this.isExportButtonDisabled =
          exportStatus?.[0]?.exportJobRunning ?? false;
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // set active tab(email/vault)
    emailVaultTabsDisplay() {
      const tabType = this.$route?.meta?.tabType;

      this.showTabs = tabType !== undefined;
      if (tabType !== undefined) {
        this.activeTab = tabType;
      }
    },
    //get count of tags in a project
    getTagsCount() {
      let tags = this.$route.params.tagname;

      let tagsCount = 0;

      if (tags) {
        const routeTags = this.$route.params.tagname.split(',');
        this.allTags.forEach(tagItem => {
          const routeTagIndex = routeTags.findIndex(
            routeTagItem => tagItem.tag === routeTagItem
          );
          if (routeTagIndex !== -1) {
            tagsCount += this.allTags[routeTagIndex].count;
          }
        });
      }
      return tagsCount;
    },
    /**
     * go to @param {String} forWhat route
     */
    gotoURL(forWhat) {
      if (forWhat === 'archive' && this.activeTab === 0) {
        return;
      }
      if (forWhat === 'vault' && this.activeTab === 1) {
        return;
      }
      if (this.isArchives) {
        if (this.isTags) {
          let tags = this.$route.params.tagname;
          let path =
            forWhat === 'archive'
              ? `/discovery/projects/${this.projectId}/archives/tags/${tags ||
                  ''}`
              : `/discovery/projects/${
                  this.projectId
                }/archives/vault/tags/${tags || ''}`;
          return this.$router.replace(path);
        }
        let path =
          forWhat === 'archive'
            ? `/discovery/projects/${this.projectId}/archives/p1`
            : `/discovery/projects/${this.projectId}/archives/vault/p1`;
        return this.$router.replace(path);
      }
      let path =
        forWhat === 'archive'
          ? `/discovery/projects/${this.projectId}`
          : `/discovery/projects/${this.projectId}/vault/p1`;
      this.$router.replace(path);
    },
    // get tags and comments in the project
    async getTagsAndComments() {
      this.allTags = [];
      let tagsComments = await ProjectService.getTagsAndComments(
        this.$route.params.projectId
      );
      this.allTags = tagsComments.data.body.tags;
      this.allComments = tagsComments.data.body.comments;
    },
    // to open dialog
    openDialog() {
      if (this.projectDetails.archiveIds === 0) {
        this.snackbar('info', this.$message.NO_ARCHIVE_EXPORT);
        return;
      }
      this.dialogOpen = true;
    },
    // to close dialog
    closeDialog() {
      this.dialogOpen = false;
    },
    // go one route back
    goback() {
      this.$router.go(-1);
    },
    // export the email and vault archive
    async exportArchives(exportTo) {
      try {
        const connectorName =
          this.connectorArchiveNameMap(exportTo)?.title || '';

        this.isExportButtonDisabled = true;
        this.loadingState = true;
        const projectId = this.$route.params.projectId;
        await this.$services.project.exportArchives(projectId, exportTo);
        this.snackbar('success', this.$message.EXPORT_QUEUED(connectorName));
        this.toggleExportModal();
      } catch (err) {
        this.isExportButtonDisabled = false;
        this.snackbar('error', err);
      } finally {
        this.loadingState = false;
      }
    },
    // to archive a project
    async archiveProject() {
      await ProjectService.archiveProject(this.$route.params.projectId);
      let openProjects = this.getOpenProjects();
      let newList = openProjects.filter(
        project => project.projectSlug !== this.$route.params.projectId
      );
      // update the store
      this.setOpenProjects(newList);

      this.snackbar('success', this.$message.PROJECT_ARCHIVED);
      this.backToOverview();
    },
    /**
     * to get all user object
     * @param {Array} userList
     */
    formatUsers(userList) {
      let allUserObj = {};
      userList.forEach(user => {
        allUserObj[user.id] = user;
      });
      return allUserObj;
    },
    // to get all users
    async getAllUsers() {
      let users = await UserService.loadUsersAll(false, true, 'DISCOVERY');
      users = users.data.body[0].results;
      this.allUserArr = users;
      this.allUserObj = this.formatUsers(users);
      this.getProjectData(this.$route.params.projectId);
    },
    /**
     * to get project data
     * @param {String} projectSlug
     */
    async getProjectData(projectSlug) {
      let projectDetails = await ProjectService.projectDetails(projectSlug);
      if (!projectDetails.data.success) {
        this.backToSearch();
        return;
      }
      this.projectDetails = projectDetails.data.body[0];
      // push this to store if not already present there
      this.openProjectTab(
        {
          projectSlug: this.$route.params.projectId,
          projectName: this.projectDetails.projectName
        },
        false,
        'overview'
      );
      this.$store.state.projectDetails = this.projectDetails;
      this.dataReady = true;
    },
    // back to overview route
    backToOverview() {
      this.$router.push({ path: '/discovery/overview/current' });
    },
    // back to that project with advance search component
    backToSearch() {
      this.$router.push({
        path: '/discovery/projects/' + this.$route.params.projectId
      });
    },
    toggleExportModal() {
      if (!this.isOrgOnboarded) {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
        return;
      }

      this.exportDialogState = !this.exportDialogState;
    }
  }
};
</script>

<style scoped>
.tab-count {
  font-size: 12px;
}
</style>
<style>
.project-actions-loader {
  height: 36px;
}
.project-actions-loader .v-skeleton-loader__actions {
  padding: 0px;
  margin-bottom: 0px;
}
</style>
